import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = () => {};
  }
  getEnvConfig();
}
declare var APIGateway: any;


function getEnvConfig() {
  const http = new XMLHttpRequest();
  const timeStamp = + new Date();
  http.open('GET', `./assets/lender/data/environment.json?${timeStamp}`, true);
  http.timeout = 10000;
  http.send(JSON.stringify(''));

  http.onerror = (error) => {
    reload(http.status);
  };

  http.ontimeout = () => {
    reload(http.status);
  };

  http.onreadystatechange = (e) => {
    if (http.readyState === 4) {
      if (http.status === 200) {
        try {
          const res = JSON.parse(http.response);
          setEnv(res);
          platformBrowserDynamic().bootstrapModule(AppModule);
        } catch (e) {
          console.log(e)
          alert('Configured environment in: /assets/lender/data.environment.json is wrong. Please recheck your json file.');
          return;
        }
      } else {

        alert('Environmet File path is incorrect');
        return;
      }
    }
  };
}

function setEnv(res) {
  var apiGateway = new APIGateway().getEncryptionAPI();
  try {
    res = JSON.parse(apiGateway.aesEncryption.decryptText(res.envConfig, 'decimalsecretkey'));
    if (!res.enableLogging && window) window.console.log = function () { };
  } catch (error) {
    console.log(error)
    alert('Error while decrypting Enviornment');
    console.error(error);
  }
  environment.envProps = res.envProps;
}

function reload(s) {
  let r = confirm("Unable to reload the env file." + " Error: " + s + " Do you want to reload?")
  if (r) {
    window.location.reload();
  } else {
    return;
  }
}












